import { authBg } from "assets/images";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { mySiteDetailsApi } from "services/mySites";
import { capitalize, formatDate } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

const SiteDetails = () => {
  const { folderName, id } = useParams()
  const [sitesDetails, setSitesDetails] = useState({})
  const [loading, setLoading] = useState(false)
  // console.log('sitesDetails', sitesDetails)
  //--------site-listing--------------
  useEffect(() => {
    const mySiteDetails = async () => {
      try {
        setLoading(true)
        const res = await mySiteDetailsApi({ siteId: id })
        if (res?.status === 200) {
          const data = res?.data?.site
          // console.log('data', data)
          setSitesDetails(data || {})
        } else {
          failMessage(res)
        }
      } catch (e) {
        console.log('error', e?.message)
      } finally {
        setLoading(false)
      }
    }
    mySiteDetails()
  }, [id])

  return (
    <div className="site_details">
      <div className="breadcrumb_wrap">
        <ul>
          <li>
            <Link to={-1}>My Sites</Link>
          </li>
          <li>{folderName}</li>
        </ul>
      </div>
      <div className="site_details_content">
        <div className="banner_image">
          <img src={sitesDetails?.siteImage || authBg} alt="" />
        </div>
        <ul>
          <li>
            <span>Site Name</span>
            <b>{sitesDetails?.siteName || 'N/A'}</b>
          </li>
          <li>
            <span>Site Size</span>
            <b>{sitesDetails?.moduleSize || "N/A"}</b>
          </li>
          <li>
            <span>Solar Panel Brand</span>
            <b>{sitesDetails?.moduleBrand || "N/A"}</b>
          </li>
          <li>
            <span>Solar Inverter Brand</span>
            <b>{sitesDetails?.inverterBrand || "N/A"}</b>
          </li>
          <li>
            <span>Commissioning Date</span>
            <b>{formatDate(sitesDetails?.commissioningDate)}</b>
          </li>
          <li>
            <span>Net Metering Date</span>
            <b>{formatDate(sitesDetails?.netMeteringDate)}</b>
            {/* <b>19/02/2025</b> */}
          </li>
          <li>
            <span>Project Tenure</span>
            {/* <b>60 Months N/A</b> */}
            <b>{sitesDetails?.projectTenure || "N/A"}</b>
          </li>
          <li>
            <span>Tax Saving</span>
            <b>{sitesDetails?.taxBenefitSharing ? `${sitesDetails?.taxBenefitSharing}%` : 'N/A'}</b>
          </li>
          <li>
            <span>Tax Saving Payable</span>
            <b>{sitesDetails?.taxBenefitApplicability || "N/A"}</b>
          </li>
          <li>
            <span>Project Tariff Rate</span>
            {sitesDetails?.projectTariff?.length > 0 ? (
              <b>{sitesDetails.projectTariff.map((data) => `${data.month} - ₹${data.amount}`).join(", ")}</b>
            ) : (
              <b>N/A</b>
            )}
          </li>

          <li>
            <span>Site Address</span>
            <b>
              {sitesDetails?.projectCity && sitesDetails?.projectState
                ? `${capitalize(sitesDetails.projectState)}, ${capitalize(sitesDetails.projectCity)}`
                : "N/A"}
            </b>
          </li>
          <li>
            <span>GST Applicability</span>
            <b>{sitesDetails?.gstApplicability || "N/A"}</b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SiteDetails;
